<div class="section position-relative">
    <div class="section-top">
        <h3 class="section-title">Template-uri documente oficiale</h3>
        <div class="section-top-actions">
            <button type="button" class="btn btn-sm btn-info pull-right ms-1" (click)="rerenderDT(false)">
                <i class="fa-solid fa-arrows-rotate"></i>
            </button>
            <button *ngIf="permissionsService.hasPermission('dgaspc-module.settings.template-documente.add')"
                type="button" class="btn btn-sm btn-primary pull-right ms-1" (click)="openAddDialog()">
                <i class="fa-solid fa-plus"></i>
                Adaugă
            </button>
            <!-- <button *ngIf="permissionsService.hasPermission('dgaspc-module.settings.template-documente.add')"
                type="button" class="btn btn-sm btn-secondary pull-right ms-1" (click)="openTemplateParameters()">
                <i class="fa-solid fa-cog"></i>
                Parametri
            </button>
            <button *ngIf="permissionsService.hasPermission('dgaspc-module.settings.template-documente.add')"
                type="button" class="btn btn-sm btn-warning pull-right ms-1" (click)="openSmartTemplateAssignments()">
                <i class="fa-solid fa-link"></i>
                Asignări
            </button>
            <button *ngIf="permissionsService.hasPermission('dgaspc-module.settings.template-documente.view')"
                type="button" class="btn btn-sm btn-purple pull-right ms-1" (click)="openSmartTemplateManagement()">
                <i class="fa-solid fa-list-check"></i>
                Gestionare Smart Templates
            </button>
            <button *ngIf="permissionsService.hasPermission('dgaspc-module.settings.template-documente.add')"
                type="button" class="btn btn-sm btn-success pull-right ms-1" (click)="openSmartTemplateBuilder()">
                <i class="fa-solid fa-magic-wand-sparkles"></i>
                Smart Template
            </button> -->
        </div>
    </div>

    <div class="card-container p-2" *ngIf="showCard">
        <div class="row">
            <div class="col-md-12">
                <mat-form-field class="w-100">
                    <mat-label>Activ</mat-label>
                    <mat-select [(ngModel)]="activeValue">
                        <mat-option *ngFor="let param of parameters" [value]="param.value">
                            {{ param.key }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <form [formGroup]="searchParamsForm">
            <div class="row">
                <div class="col-md-6">
                    <mat-form-field class="w-100">
                        <mat-label>Nume Template</mat-label>
                        <input matInput formControlName="name">
                    </mat-form-field>
                </div>

                <div class="col-md-6">
                    <mat-form-field class="w-100">
                        <mat-label>Tip Adresă?</mat-label>
                        <mat-select formControlName="address_type">
                            <mat-option *ngFor="let param of parameters" [value]="param.value">
                                {{ param.key }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <mat-form-field class="w-100">
                        <mat-label>Direcție/Instituție</mat-label>
                        <mat-select formControlName="directie_id" (openedChange)="onDirectieSelectClosed()"
                            (selectionChange)="onDirectieChange($event.value)">
                            <mat-form-field class="px-2 w-100 sticky-input">
                                <input matInput [formControl]="directiiControl" (keydown)="$event.stopPropagation()"
                                    (click)="$event.stopPropagation()" />
                            </mat-form-field>

                            <mat-option *ngIf="filteredDirectii.length === 0" disabled>
                                <span>No results found</span>
                            </mat-option>

                            <mat-option [value]="-1">-- Alegeți --</mat-option>
                            <mat-option *ngFor="let directie of filteredDirectii" [value]="directie.id">
                                {{ directie.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <mat-form-field class="w-100">
                        <mat-label>Compartiment/Serviciu</mat-label>
                        <mat-select (openedChange)="onCompartimenteSelectClosed()" formControlName="compartiment_id">
                            <mat-form-field class="px-2 w-100 sticky-input">
                                <input matInput [formControl]="compartimenteControl"
                                    (keydown)="$event.stopPropagation()" (click)="$event.stopPropagation()" />
                            </mat-form-field>

                            <mat-option *ngIf="filteredCompartimente.length === 0" disabled>
                                <span>No results found</span>
                            </mat-option>

                            <mat-option [value]="-1">-- Alegeți --</mat-option>
                            <mat-option *ngFor="let compartiment of filteredCompartimente" [value]="compartiment.id">
                                {{ compartiment.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <!-- New Enhanced Filters Row -->
            <div class="row">
                <div class="col-md-6">
                    <mat-form-field class="w-100">
                        <mat-label>Registru</mat-label>
                        <mat-select formControlName="registry_id">
                            <mat-option [value]="-1">-- Toate Registrele --</mat-option>
                            <mat-option [value]="0">Fără registru</mat-option>
                            <mat-option *ngFor="let registry of registriesList" [value]="registry.id">
                                {{ registry.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6">
                    <mat-form-field class="w-100">
                        <mat-label>Necesită Draft?</mat-label>
                        <mat-select formControlName="draft_status">
                            <mat-option *ngFor="let param of parameters" [value]="param.value">
                                {{ param.key }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </form>

        <div class="row">
            <div class="col-md-12">
                <mat-form-field class="w-100">
                    <mat-label>Căutare Categorie</mat-label>
                    <input matInput [(ngModel)]="categorySearch" placeholder="Tastați pentru a căuta categorii..."
                        (input)="onCategorySearchChange($event)">
                    <mat-hint *ngIf="categorySearch && categorySearchResults.length > 0">
                        {{ categorySearchResults.length }} rezultate găsite
                    </mat-hint>
                </mat-form-field>
                <div *ngIf="categorySearch && categorySearchResults.length > 0"
                    class="category-dropdown mt-1 border rounded shadow-sm bg-white position-absolute"
                    style="z-index: 1000; max-height: 200px; overflow-y: auto; width: 100%;">
                    <div *ngFor="let category of categorySearchResults"
                        class="p-2 cursor-pointer border-bottom hover-bg-light" (click)="selectCategory(category)"
                        [class.bg-light]="selectedCategoryId === category.id">
                        <small class="text-muted">#{{ category.id }}</small>
                        <strong class="ms-2">{{ category.name }}</strong>
                        <div class="text-muted small" *ngIf="category.path">{{ category.path }}</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="section-spinner position-absolute" *ngIf="isFilterLoading">
            <div class="spinner position-absolute top-50 start-50 translate-middle">
                <mat-spinner></mat-spinner>
                <h3 class="mt-2">
                    {{ helper.dialogConfig.generalMessages.pleaseWait }}
                </h3>
            </div>
        </div>

        <div class="row w-100">
            <div class="col d-flex justify-content-start">
                <button (click)="toggleCard()" type="button" class="btn btn-sm btn-warning closeBtn">Închide</button>
            </div>
            <div class="col buttons-submit">
                <button (click)="resetForm()" type="button" class="btn btn-sm btn-secondary">
                    Resetează
                </button>
                <button (click)="applyFilters()" type="submit" class="btn btn-sm btn-primary ms-2">
                    Aplică
                </button>
            </div>
        </div>
    </div>
    <div class="col-sm-12 ps-3">
        <button type="button" class="btn btn-sm btn-default" (click)="toggleCard()" [class.active]="showCard">
            <i class="fa-solid fa-filter"></i> Filtre
        </button>
    </div>
    <div class="table-container">
        <table id="datatable" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="row-border hover w-100">
        </table>
    </div>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>